var _class;
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Box, Button, Flex, Text } from 'core/components';
import { Field, formConsumer, Select } from 'core/form';
import { SortableMenu } from 'app/views/boards/panels/ude/SortableMenu';
import { Position } from '@blueprintjs/core';
import DimensionMenu from 'app/views/boards/panels/ude/components/DimensionMenu';
import DropdownMenu from 'core/components/DropdownMenu';
import { getGroupedDimensions } from 'app/stores/ude/measurementTransforms';
// @ts-expect-error - fix typing for formConsumer
let UdePanelDimensions = formConsumer(_class = observer(_class = class UdePanelDimensions extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      isDropdownOpen: false
    };
    this.handleRemoveDimension = dimensionName => {
      const {
        form
      } = this.props;
      const currentDimensions = form.getValue('config.data.dimensions') || [];
      const updatedDimensions = currentDimensions.filter(dimension => dimension.name !== dimensionName);
      form.setValue('config.data.dimensions', updatedDimensions);
    };
    this.handleOpenAddDimension = () => {
      this.setState({
        isDropdownOpen: true
      });
    };
    this.handleAddDimension = newDim => {
      const {
        form
      } = this.props;
      const currentDimensions = form.getValue('config.data.dimensions') || [];
      const newDimName = typeof newDim === 'string' ? newDim : newDim.key;
      const existingIndex = currentDimensions.findIndex(dimension => dimension.name === newDimName);
      if (existingIndex >= 0) {
        // remove if already selected
        form.setValue('config.data.dimensions', currentDimensions.filter((_, i) => i !== existingIndex));
      } else {
        form.setValue('config.data.dimensions', [...currentDimensions, {
          name: newDimName
        }]);
      }
    };
    this.handleReorder = ({
      oldIndex,
      newIndex
    }) => {
      const {
        form
      } = this.props;
      const currentDimensions = form.getValue('config.data.dimensions') || [];
      const updatedDimensions = Array.from(currentDimensions);
      const [movedDimension] = updatedDimensions.splice(oldIndex, 1);
      updatedDimensions.splice(newIndex, 0, movedDimension);
      form.setValue('config.data.dimensions', updatedDimensions);
    };
  }
  render() {
    const {
      form,
      measurements,
      measurementHash,
      appProtocols,
      headerVariant
    } = this.props;
    const {
      isDropdownOpen
    } = this.state;
    const measurement = form.getValue('config.data.measurement');
    const metrics = form.getValue('config.data.metrics') || [];
    const dimensions = form.getValue('config.data.dimensions') || [];
    const hasMeasurement = !!measurement;
    const disabledDimensions = new Set(metrics.map(metric => metric.name));
    const content = /*#__PURE__*/React.createElement(Flex, {
      flexDirection: "column",
      px: "12px",
      pt: 0,
      pb: 0,
      display: "flex",
      gap: 1
    }, !dimensions?.length && /*#__PURE__*/React.createElement(Text, {
      muted: true,
      small: true,
      fontWeight: "normal"
    }, "No dimensions selected"), dimensions?.length > 0 && /*#__PURE__*/React.createElement(SortableMenu, {
      measurement: form.getValue('config.data.measurement') || '',
      type: "dimension",
      handleRemoveItem: this.handleRemoveDimension,
      measurements: measurements,
      items: dimensions,
      onSortEnd: this.handleReorder
    }), measurement?.startsWith('/metrics/') && /*#__PURE__*/React.createElement(Field, {
      name: "config.data.reAgg.fn",
      mt: 2,
      mb: 0
    }, /*#__PURE__*/React.createElement(Select, null)));

    // TODO: we probably want to memoize this and pull it out into a single place
    const groupedDimensions = getGroupedDimensions(measurement ?? '', measurementHash).map(group => ({
      ...group,
      items: group.items.filter(item => !item.nodeData?.FilterOnly)
    })).filter(group => group.items.length > 0);
    const addButton = hasMeasurement ? /*#__PURE__*/React.createElement(Box, {
      ml: "auto"
    }, /*#__PURE__*/React.createElement(DropdownMenu, {
      isOpen: isDropdownOpen,
      onInteraction: (nextOpenState, e) => {
        if (nextOpenState) {
          this.setState({
            isDropdownOpen: true
          });
          return;
        }
        // Suppress close events originating from inside the popover content (menu item clicks).
        // Only allow close from Escape or outside-click.
        const target = e?.target ?? null;
        const isInsideContent = !!target?.closest('.ude-dimension-selector-popover');
        const isEscape = e?.key === 'Escape';
        if (isInsideContent && !isEscape) {
          return;
        }
        this.setState({
          isDropdownOpen: false
        });
      },
      position: Position.RIGHT_TOP,
      popoverClassName: "ude-dimension-selector-popover",
      boundary: "viewport",
      modifiers: {
        flip: {
          enabled: true
        },
        hide: {
          enabled: false
        },
        preventOverflow: {
          enabled: true
        }
      },
      usePortal: true,
      canEscapeKeyClose: true,
      content: /*#__PURE__*/React.createElement(DimensionMenu, {
        measurement: measurement,
        measurementHash: measurementHash,
        groupedDimensions: groupedDimensions,
        selectedDimensions: dimensions,
        disabledDimensions: disabledDimensions,
        appProtocols: appProtocols,
        onSelect: this.handleAddDimension
      })
    }, /*#__PURE__*/React.createElement(Button, {
      small: true,
      minimal: true,
      intent: "primary",
      text: "Add",
      onClick: this.handleOpenAddDimension,
      active: isDropdownOpen
    }))) : null;
    return headerVariant === 'pane' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Flex, {
      alignItems: "center",
      gap: 1,
      p: "6px 8px 6px 16px"
    }, /*#__PURE__*/React.createElement(Text, {
      small: true,
      fontWeight: "bold",
      style: {
        textTransform: 'uppercase'
      }
    }, "Dimensions"), addButton), content) : /*#__PURE__*/React.createElement(Flex, {
      flexDirection: "column",
      pb: "12px"
    }, /*#__PURE__*/React.createElement(Flex, {
      alignItems: "center",
      gap: 1,
      p: "6px 8px 6px 16px"
    }, /*#__PURE__*/React.createElement(Text, {
      small: true,
      fontWeight: "bold",
      style: {
        textTransform: 'uppercase'
      }
    }, "Dimensions"), addButton), content);
  }
}) || _class) || _class;
export default UdePanelDimensions;